import { render } from "./OrganizerView.vue?vue&type=template&id=cf2e21ba&scoped=true"
import script from "./OrganizerView.vue?vue&type=script&lang=js"
export * from "./OrganizerView.vue?vue&type=script&lang=js"

import "./OrganizerView.vue?vue&type=style&index=0&id=cf2e21ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2e21ba"]])

export default __exports__